/* PDP only (loaded by sections/main-product.liquid): a gallery with more than six pictures (a colour's own list, or every picture of the product)
   is a grid that shows six at a time on a desktop; an arrow on each side goes to the previous / next six (the arrows are always there),
   and a dot under the gallery for each page shows where you are (a tap on a dot goes to that page).
   The pages also turn with a drag: with the mouse (or a finger on a tablet) the pages follow the pointer, side by side, and a drag to the left
   brings the next six, a drag to the right the previous six.
   A page change is one smooth slide: the page that leaves and the page that comes are next to each other and move together (no fading), and nothing
   else moves: the gallery is as high as its tallest page, so the page below it never jumps and never has to be scrolled back.
   On a phone every picture is a slide, with one dot per picture (pdp-gallery-dots.js).
   The pages also turn by themselves every few seconds when AUTOPLAY_MS is set (paused while the mouse is over the gallery) */
(function () {
  var PAGE_SIZE = 6;
  var GAP = 8; // px between two pages while they slide
  var DURATION = 460; // ms of a whole slide
  var desktop = window.matchMedia('(min-width: 750px)');
  var gallery;
  var list;
  var slider; // what the grid sits in: it clips the pages that wait at its sides while they slide
  var previous;
  var next;
  var dots;
  var page = 0; // the page that is on screen
  var heading = null; // the page the gallery is sliding to
  var queued = null; // a page asked for while the gallery slides: it follows
  var animating = false;
  var ghost = null; // a copy of the grid that shows the page next to the one on screen while they slide
  var ghostDir = 0; // 1: the ghost is on the right (the next page), -1: on the left
  var ghostPage = -1;
  var firstId = null;
  var lockKey = '';
  var preloading = false;
  var scheduled = false;
  var timer;
  var AUTOPLAY_MS = 0; // 0 = the pages only turn with the arrows (set e.g. 4000 to turn by themselves every 4 seconds)
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function items() {
    return Array.prototype.filter.call(list.children, function (item) {
      return item.hasAttribute('data-media-id');
    });
  }

  // the page the gallery is on or on its way to (the last one asked for)
  function logical() {
    if (queued !== null) return queued;
    return heading !== null ? heading : page;
  }

  function arrow(direction, label) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'pdp-gallery-pager pdp-gallery-pager--' + (direction < 0 ? 'previous' : 'next');
    button.setAttribute('aria-label', label);
    button.innerHTML =
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' +
      (direction < 0 ? 'M15 5L8 12L15 19' : 'M9 5L16 12L9 19') +
      '"/></svg>';
    button.addEventListener('click', function () {
      goTo(logical() + direction, 0, button);
    });
    return button;
  }

  function pageCount() {
    return Math.ceil(items().length / PAGE_SIZE);
  }

  // which pictures are on screen: those of page `shown` (all of them when the gallery is not paged)
  function setShown(shown, paged) {
    items().forEach(function (item, index) {
      item.classList.toggle('pdp-page-hidden', paged && Math.floor(index / PAGE_SIZE) !== shown);
    });
  }

  // the gallery is as high as its tallest page (the last page has fewer pictures): changing page does not change the height of the page, so nothing
  // under the gallery moves. Measured when the pictures or the width change.
  function lockHeight(pages) {
    var key = items().length + ':' + Math.round(list.clientWidth);
    if (key === lockKey) return;
    lockKey = key;
    list.style.minHeight = '';
    var tallest = 0;
    for (var index = 0; index < pages; index++) {
      setShown(index, true);
      tallest = Math.max(tallest, list.offsetHeight);
    }
    setShown(page, true);
    list.style.minHeight = tallest + 'px';
  }

  // the pictures of the other pages are loaded in advance (they sit in a hidden part of the grid, where "lazy" pictures would wait for ever)
  function preload() {
    items().forEach(function (item) {
      var picture = item.querySelector('img[loading="lazy"]');
      if (picture) picture.loading = 'eager';
    });
  }

  // arrows and dots show the page they are leading to
  function indicate(index, pages) {
    previous.disabled = index === 0;
    next.disabled = index >= pages - 1;
    Array.prototype.forEach.call(dots.children, function (dot, i) {
      dot.classList.toggle('is-active', i === index);
      if (i === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  // ---- the two pages side by side

  function distance() {
    return list.offsetWidth + GAP;
  }

  // a copy of the grid, showing page `index`, laid next to the real grid (on its right for the next page, on its left for the previous one)
  function makeGhost(index, direction) {
    removeGhost();
    var copy = list.cloneNode(true);
    var count = 0;
    Array.prototype.forEach.call(list.children, function (item, i) {
      if (!item.hasAttribute('data-media-id')) return;
      copy.children[i].classList.toggle('pdp-page-hidden', Math.floor(count / PAGE_SIZE) !== index);
      count++;
    });
    // a copy is only a picture of the page: no ids, nothing the lightbox or the theme could take for a second set of pictures
    Array.prototype.forEach.call(copy.querySelectorAll('[id], [data-media-id], [data-fancybox-src]'), function (element) {
      element.removeAttribute('id');
      element.removeAttribute('data-media-id');
      element.removeAttribute('data-fancybox-src');
    });
    copy.removeAttribute('id');
    copy.classList.add('pdp-gallery-ghost');
    copy.setAttribute('aria-hidden', 'true');
    copy.inert = true;
    copy.style.cssText =
      'position:absolute;top:0;left:0;margin:0;pointer-events:none;width:' +
      list.offsetWidth +
      'px;min-height:' +
      (list.style.minHeight || '0px') +
      ';transform:translateX(' +
      direction * distance() +
      'px)';
    list.insertAdjacentElement('afterend', copy);
    // the pages that wait outside the gallery are cut off (and do not widen the page)
    slider.style.overflow = 'hidden';
    slider.style.overflow = 'clip';
    ghost = copy;
    ghostDir = direction;
    ghostPage = index;
  }

  function removeGhost() {
    if (ghost) ghost.remove();
    ghost = null;
    ghostPage = -1;
    slider.style.overflow = '';
  }

  // the real grid is `offset` px from its place, the ghost keeps its distance from it
  function place(offset) {
    list.style.transform = 'translateX(' + offset + 'px)';
    if (ghost) ghost.style.transform = 'translateX(' + (offset + ghostDir * distance()) + 'px)';
  }

  // a page change is instant (no slide): the new six are simply there
  function canAnimate() {
    return false;
  }

  // The height of the gallery follows its page (the last page has fewer pictures), which moves everything under it:
  // the arrow / dot that was clicked is kept at the same place on the screen (under the mouse), so a click never makes the page jump away
  function goTo(target, offset, anchor) {
    if (target < 0 || target >= pageCount()) return;
    if (animating) {
      queued = target === heading ? null : target;
      return;
    }
    if (target === page) return;
    if (!canAnimate()) {
      removeGhost();
      list.style.transform = '';
      var held = anchor || gallery;
      var before = held.getBoundingClientRect().top;
      page = target;
      apply();
      var shift = held.getBoundingClientRect().top - before;
      if (shift) window.scrollBy({ top: shift, left: 0, behavior: 'instant' });
      return;
    }
    slide(target, offset || 0);
  }

  function done() {
    animating = false;
    var waiting = queued;
    queued = null;
    if (waiting !== null) goTo(waiting);
  }

  // the grid and its neighbour move together to the page asked for: from `offset` (where the grid is: 0, or where a drag left it)
  function slide(target, offset) {
    var direction = target > page ? 1 : -1;
    if (!ghost || ghostPage !== target || ghostDir !== direction) makeGhost(target, direction);
    var far = distance();
    var left = Math.abs(-direction * far - offset) / far; // the part of the way that is left
    var options = { duration: Math.round(Math.max(240, DURATION * left)), easing: 'cubic-bezier(0.45, 0, 0.2, 1)', fill: 'forwards' };
    animating = true;
    heading = target;
    indicate(target, pageCount());
    list.style.transform = '';
    ghost.style.transform = '';

    var moveList = list.animate([{ transform: 'translateX(' + offset + 'px)' }, { transform: 'translateX(' + -direction * far + 'px)' }], options);
    var moveGhost = ghost.animate([{ transform: 'translateX(' + (offset + direction * far) + 'px)' }, { transform: 'translateX(0)' }], options);
    moveList.onfinish = function () {
      // the real grid takes over the page the ghost showed, in the same frame: nothing flickers
      page = target;
      heading = null;
      apply();
      moveList.cancel();
      moveGhost.cancel();
      removeGhost();
      done();
    };
  }

  // a drag that did not turn the page: the grid and its neighbour go back
  function settle(offset) {
    if (!canAnimate() || (!ghost && !offset)) {
      removeGhost();
      list.style.transform = '';
      return;
    }
    var far = distance();
    var options = { duration: Math.round(Math.max(180, (DURATION * Math.abs(offset)) / far)), easing: 'cubic-bezier(0.45, 0, 0.2, 1)', fill: 'forwards' };
    animating = true;
    list.style.transform = '';
    var moveList = list.animate([{ transform: 'translateX(' + offset + 'px)' }, { transform: 'translateX(0)' }], options);
    var moveGhost = ghost
      ? ghost.animate([{ transform: 'translateX(' + (offset + ghostDir * far) + 'px)' }, { transform: 'translateX(' + ghostDir * far + 'px)' }], options)
      : null;
    if (ghost) ghost.style.transform = '';
    moveList.onfinish = function () {
      moveList.cancel();
      if (moveGhost) moveGhost.cancel();
      removeGhost();
      done();
    };
  }

  // ---- drag: with the mouse (or a finger on a tablet) the pages follow the pointer, side by side. A drag to the left brings the next six pictures,
  // a drag to the right the previous six. A click with a little shake of the hand stays a click (it opens the picture),
  // the click that ends a real drag is swallowed.
  var DRAG_START = 6; // px before a press-and-move is a drag
  var DRAG_PAGE = 60; // px of drag (or 30px with a quick flick, over 0.35px per ms) that turns the page
  var drag = null;
  var justDragged = false;

  function canDrag() {
    return desktop.matches && pageCount() > 1 && !animating;
  }

  function endDrag() {
    window.removeEventListener('pointermove', onPointerMove);
    window.removeEventListener('pointerup', onPointerUp);
    window.removeEventListener('pointercancel', onPointerUp);
    document.documentElement.classList.remove('pdp-gallery-dragging');
    drag = null;
  }

  // the click that follows the next release of the mouse is swallowed (the release itself fires it a moment after)
  function swallowNextClick() {
    justDragged = true;
    window.addEventListener(
      'pointerup',
      function () {
        setTimeout(function () {
          justDragged = false;
        }, 80);
      },
      { once: true }
    );
  }

  function onPointerDown(event) {
    if (drag || !canDrag()) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    // the controls keep their own clicks (the arrows, the dots, the heart); the button laid over each picture (it opens the lightbox) does not count as a control
    if (event.target.closest('button:not(.product__media-toggle), a, input, select, textarea, .pdp-gallery-pager, .pdp-gallery-pages')) return;
    drag = { id: event.pointerId, x: event.clientX, y: event.clientY, time: event.timeStamp, active: false, offset: 0, mouse: event.pointerType === 'mouse' };
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);
  }

  function onPointerMove(event) {
    if (!drag || event.pointerId !== drag.id) return;
    var dx = event.clientX - drag.x;
    var dy = event.clientY - drag.y;
    if (drag.moved === undefined) drag.moved = event.timeStamp; // the speed is measured from the first move, not from the press
    if (!drag.active) {
      // a mostly vertical move is the page being scrolled (a finger), not a drag of the gallery
      if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) {
        // with a mouse this is not a click either (a press that is dragged 12px away and let go on the same picture): the click is swallowed
        if (drag.mouse) swallowNextClick();
        return endDrag();
      }
      if (Math.abs(dx) < DRAG_START) return;
      drag.active = true;
      document.documentElement.classList.add('pdp-gallery-dragging');
      if (window.getSelection) window.getSelection().removeAllRanges();
    }
    var far = distance();
    var direction = dx < 0 ? 1 : -1; // the page the drag leads to: the next one when it goes to the left
    var neighbour = page + direction;
    // the grid follows the pointer a little; the page changes when it is let go
    drag.offset = Math.max(-140, Math.min(140, Math.round(dx * (neighbour >= 0 && neighbour < pageCount() ? 0.35 : 0.2))));
    place(drag.offset);
  }

  function onPointerUp(event) {
    if (!drag || event.pointerId !== drag.id) return;
    var finished = drag;
    var dx = event.clientX - finished.x;
    var quick = Math.abs(dx) / Math.max(1, event.timeStamp - (finished.moved === undefined ? finished.time : finished.moved)) > 0.35;
    var target = page + (dx < 0 ? 1 : -1);
    var turns = finished.active && event.type !== 'pointercancel' && (Math.abs(dx) >= DRAG_PAGE || (Math.abs(dx) >= 30 && quick)) && target >= 0 && target < pageCount();
    endDrag();
    if (!finished.active) return;
    justDragged = true;
    setTimeout(function () {
      justDragged = false;
    }, 80);
    if (turns) goTo(target, finished.offset);
    else settle(finished.offset);
  }

  function autoplay() {
    clearInterval(timer);
    if (!AUTOPLAY_MS || reduceMotion.matches || !desktop.matches || pageCount() < 2) return;
    timer = setInterval(function () {
      if (document.hidden || gallery.matches(':hover')) return;
      goTo(page + 1 < pageCount() ? page + 1 : 0);
    }, AUTOPLAY_MS);
  }

  // one dot per page (rebuilt when the number of pages changes, e.g. after another colour is chosen)
  function renderDots(pages, paged) {
    dots.hidden = !paged;
    if (dots.children.length !== pages) {
      dots.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pdp-gallery-dots__dot';
          dot.setAttribute('aria-label', 'Pictures ' + (index * PAGE_SIZE + 1) + ' to ' + Math.min(items().length, (index + 1) * PAGE_SIZE));
          dot.addEventListener('click', function () {
            goTo(index, 0, dot);
          });
          dots.appendChild(dot);
        })(i);
      }
    }
    indicate(page, pages);
  }

  // the gallery keeps the height of its tallest page, so a short last page leaves room under its pictures: the dots move up to sit right under them
  // (what is under the dots stays where it is)
  function tuckDots(paged) {
    var shift = 0;
    if (paged) {
      var shown = items().filter(function (item) {
        return item.offsetParent !== null;
      });
      if (shown.length) {
        var content = shown[shown.length - 1].getBoundingClientRect().bottom - list.getBoundingClientRect().top;
        shift = Math.max(0, Math.round(list.getBoundingClientRect().height - content));
      }
    }
    dots.style.transform = shift ? 'translateY(' + -shift + 'px)' : '';
  }

  function apply() {
    scheduled = false;
    var all = items();
    var pages = Math.ceil(all.length / PAGE_SIZE);
    var paged = desktop.matches && pages > 1;

    // another colour (a different first picture) starts on its first page again
    var id = all.length ? all[0].getAttribute('data-media-id') : null;
    if (id !== firstId) {
      firstId = id;
      page = 0;
      lockKey = '';
    }

    page = Math.max(0, Math.min(page, pages - 1));
    if (pages > 1) gallery.setAttribute('data-paged', 'true');
    else gallery.removeAttribute('data-paged');
    list.style.minHeight = '';
    lockKey = '';
    setShown(page, paged);
    previous.hidden = next.hidden = !paged;
    renderDots(pages, paged);
    if (preloading) preload();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  }

  function init() {
    gallery = document.querySelector('.product__media-wrapper media-gallery');
    list = gallery && gallery.querySelector('.product__media-list');
    if (!list) return;
    slider = list.closest('slider-component') || list.parentElement;

    previous = arrow(-1, 'Previous pictures');
    next = arrow(1, 'Next pictures');
    gallery.appendChild(previous);
    gallery.appendChild(next);

    dots = document.createElement('div');
    dots.className = 'pdp-gallery-pages';
    dots.hidden = true;
    if (slider.tagName === 'SLIDER-COMPONENT') slider.after(dots);
    else gallery.appendChild(dots);

    new MutationObserver(function (records) {
      // the ghost is a child of the slider, not of the grid: only the pictures of the grid itself matter here
      schedule();
    }).observe(list, { childList: true });
    window.addEventListener('resize', schedule);
    desktop.addEventListener('change', function () {
      if (drag) endDrag();
      removeGhost();
      list.style.transform = '';
      apply();
      autoplay();
    });

    // the lightbox was closed on a picture: the grid shows the page of that picture at once
    document.addEventListener('pdp:lightbox-closed', function (event) {
      var target = Math.floor(event.detail.index / PAGE_SIZE);
      if (!desktop.matches || animating || pageCount() < 2 || target === page || target >= pageCount()) return;
      removeGhost();
      list.style.transform = '';
      page = target;
      apply();
    });

    list.addEventListener('pointerdown', onPointerDown);
    // the browser would drag the picture itself (a ghost image) instead of the gallery
    list.addEventListener('dragstart', function (event) {
      if (canDrag()) event.preventDefault();
    });
    // the click that ends a drag must not open the picture (the lightbox listens for clicks too: this one is first, on the window)
    window.addEventListener(
      'click',
      function (event) {
        if (!justDragged) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      },
      true
    );
    apply();
    autoplay();

    // once the page has loaded, the pictures of the other pages are fetched too
    function startPreload() {
      setTimeout(function () {
        preloading = true;
        preload();
      }, 300);
    }
    if (document.readyState === 'complete') startPreload();
    else window.addEventListener('load', startPreload);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
